"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
var InputNumber = /** @class */ (function (_super) {
    __extends(InputNumber, _super);
    function InputNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InputNumber.prototype.render = function () {
        return react_1.default.createElement(StyledAntInputNumber, __assign({}, this.props));
    };
    return InputNumber;
}(react_1.default.Component));
exports.InputNumber = InputNumber;
var StyledAntInputNumber = styled_components_1.default(antd_1.InputNumber)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    && {\n        padding: 0;\n        height: initial;\n        font-size: ", ";\n        input.ant-input-number-input {\n            padding: ", ";\n        }\n    }\n"], ["\n    && {\n        padding: 0;\n        height: initial;\n        font-size: ", ";\n        input.ant-input-number-input {\n            padding: ", ";\n        }\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.typography.bodySmall.fontSize;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.xs + " " + theme.spacing.md;
});
var templateObject_1;
//# sourceMappingURL=InputNumber.js.map